/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
/* eslint-disable no-restricted-globals */
import * as globals from './globals';

// function to format a Date object into DD/MM/YYYY format
const formatDate = (date) => {
  if (!(date instanceof Date) || isNaN(date)) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${day}/${month}/${year}`;
};

const formatDateEvent = (formattedDateInput, formattedDate) => {
  if (!formattedDateInput.value) {
    return;
  }
  setTimeout(() => formattedDateInput.value = formattedDate);
};

const handleChangeEvent = (formattedDateInput, formattedDate) => () => {
  formatDateEvent(formattedDateInput, formattedDate);
};

const getISODateString = (date) => {
  if (!(date instanceof Date)) {
    return null;
  }

  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

// function to convert a date in DD/MM/YYYY format to ISO (YYYY-MM-DD)
const convertDateToISOFormat = (inputValue) => {
  const parts = inputValue.split('/');

  // Ensure the format is converted from (MM/DD/YYYY) to ISO format (YYYY-MM-DD) for user visualization
  if (parts.length === 3) {
    const [day, month, year] = parts.map((part) => parseInt(part, 10));
    const parsedDate = getISODateString(new Date(year, month - 1, day));

    return parsedDate;
  }

  // returns original value if the inputValue doesn't have 3 slash "/" characters (expected format)
  return inputValue;
};

// Handles added error nodes by adding missing tag icon (alert icon in error message)
const handleAddedErrorNode = (node, baseSvgUrl, parentMap) => {
  const missingTagOffSvgElement = document.createElementNS(globals.NAMESPACE_SVG_URI, 'svg');
  const useElement = document.createElementNS(globals.NAMESPACE_SVG_URI, 'use');

  missingTagOffSvgElement.classList.add(globals.MISSING_TAGOFF_ICON_CLASS);
  useElement.setAttribute('href', `${baseSvgUrl}#icon-missing-tag-off`);
  missingTagOffSvgElement.appendChild(useElement);

  node.prepend(missingTagOffSvgElement);

  const datepickerElement = node.closest(`.${globals.COMPONENT_CLASS}`);
  if (datepickerElement) {
    parentMap.set(node, datepickerElement);
    const calendarBtn = datepickerElement.querySelector(globals.CALENDAR_BUTTON_SELECTOR);
    calendarBtn.classList.add(globals.CALENDAR_BUTTON_ERROR_CLASS);
  }
};

// Handles removed error nodes by removing error styling
const handleRemovedErrorNode = (node, parentMap) => {
  const datepickerElement = parentMap.get(node);
  const calendarBtn = datepickerElement.querySelector(globals.CALENDAR_BUTTON_SELECTOR);
  calendarBtn.classList.remove(globals.CALENDAR_BUTTON_ERROR_CLASS);
  parentMap.delete(node);
};

export {
  formatDate,
  handleChangeEvent,
  convertDateToISOFormat,
  handleAddedErrorNode,
  handleRemovedErrorNode,
};
